import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const BASE = "/assets/Material Documents";

const fileUrl = (relativePath) => encodeURI(`${BASE}/${relativePath}`);

const displayName = (filename) =>
  filename
    .replace(/\.pdf$/i, "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const serialFromName = (filename) => {
  const match = filename.match(/^(\d+)\.\s+/);
  return match ? match[1] : "";
};

const item = (path) => {
  const filename = path.split("/").pop();
  return {
    type: "item",
    id: serialFromName(filename),
    description: displayName(filename).replace(/^\d+\.\s+/, ""),
    link: fileUrl(path),
  };
};

const section = (title) => ({
  type: "section-header",
  title,
  bgColor: "bg-[#F26624]",
});

const subHeader = (title) => ({
  type: "sub-header",
  title,
  bgColor: "bg-gray-400",
});

const tabs = [
  {
    id: "tab1",
    label: "COI, MOA & AOA",
    rows: [
      section("1. COI"),
      item("1st Tab/1 . COI/Initial COI.PDF"),
      item("1st Tab/1 . COI/Conversion COI.pdf"),
      section("2. MOA"),
      item("1st Tab/2 . MOA/MOA/ Initial MOA.pdf"),
      item("1st Tab/2 . MOA/MOA/MOA for 10 lakhs to 1 crore.pdf"),
      item("1st Tab/2 . MOA/MOA/MOA For addition of borrowing clause.pdf"),
      item("1st Tab/2 . MOA/MOA/MOA_Increase capital to 1.20 Cr.pdf"),
      item("1st Tab/2 . MOA/MOA/Conversion MOA.pdf"),
      item("1st Tab/2 . MOA/MOA/MOA For adding of ancillary object.pdf"),
      section("3. AOA"),
      item("1st Tab/3 .AOA/Initial AOA.pdf"),
      item("1st Tab/3 .AOA/Conversion AOA.pdf"),
      item("1st Tab/3 .AOA/AOA for adding pledge of shares object.pdf"),
    ],
  },
  {
    id: "tab2",
    label: "Signed Consents",
    rows: [
      section("Signed Consents"),
      subHeader("Auditor"),
      item("2nd Tab/Signed Consents/Auditor/Consent Letter Auditor.pdf"),
      subHeader("Banker to company"),
      item("2nd Tab/Signed Consents/Banker to company/Consent Letter- HDFC Bank.pdf"),
      item("2nd Tab/Signed Consents/Banker to company/ICICI_Consentletter_BOC_IPO.pdf"),
      subHeader("Banker to offer"),
      item("2nd Tab/Signed Consents/Banker to offer/Banker to the Offer Consent letter.pdf"),
      subHeader("BRLM"),
      item("2nd Tab/Signed Consents/BRLM/consent Letter- BRLM.pdf"),
      subHeader("CFO"),
      item("2nd Tab/Signed Consents/CFO/CFO consent.pdf"),
      subHeader("CS and Compliance Officer"),
      item("2nd Tab/Signed Consents/CS and Compliance Officer/Consent of CS- Anju.pdf"),
      subHeader("Directors"),
      item("2nd Tab/Signed Consents/Directors/Consent of MD.pdf"),
      item("2nd Tab/Signed Consents/Directors/Pradeep Pasari Consent.pdf"),
      item("2nd Tab/Signed Consents/Directors/Sandeep Kumar Singh Consent.pdf"),
      item("2nd Tab/Signed Consents/Directors/Sangeeta Bhatia Consent.pdf"),
      item("2nd Tab/Signed Consents/Directors/Sheikh Arfeen Non Executive Director.pdf"),
      subHeader("Legal advisor"),
      item("2nd Tab/Signed Consents/Legal advisor/Consent of legal advisor.pdf"),
      subHeader("Market maker"),
      item("2nd Tab/Signed Consents/Market maker/Market Maker Consent Letter.pdf"),
      subHeader("PCS"),
      item("2nd Tab/Signed Consents/PCS/Signed_Consent.pdf"),
      subHeader("Promoters"),
      item("2nd Tab/Signed Consents/Promoters/Prasoon consent- Promoter.pdf"),
      item("2nd Tab/Signed Consents/Promoters/Sheikh Arfeen Ahmed Consent- Promoter.pdf"),
      subHeader("RTA"),
      item("2nd Tab/Signed Consents/RTA/RTA consent.pdf"),
      subHeader("Syndicate"),
      item("2nd Tab/Signed Consents/Syndicate/Consent Letter- Syndicate.pdf"),
      subHeader("Underwriter"),
      item("2nd Tab/Signed Consents/Underwriter/Underwriter Consent_KSL.pdf"),
      item("2nd Tab/Signed Consents/Underwriter/Underwriter Consent_Share India.pdf"),
    ],
  },
  {
    id: "tab3",
    label: "Certificates & Agreements",
    rows: [
      item("3rd Tab Documents/3. CTC_BR.pdf"),
      item("3rd Tab Documents/4. CTC_AGM.pdf"),
      item("3rd Tab Documents/5. Sole selling shareholder consent- Prasoon.pdf"),
      item("3rd Tab Documents/6. DRHPApprovalCTC.pdf"),
      item("3rd Tab Documents/7. CTC_RHP & Abridged.pdf"),
      item("3rd Tab Documents/9. Auditor's report.pdf"),
      item("3rd Tab Documents/10. CA_Special Tax Benefits.pdf"),
      item("3rd Tab Documents/12. Inprinciple letter.pdf"),
      item("3rd Tab Documents/13. BRLM_DD Report.pdf"),
      item("3rd Tab Documents/14. MD Agreement with Addendum.pdf"),
      item("3rd Tab Documents/15. Corporate Governance Certificate_2.pdf"),
      item("3rd Tab Documents/15. SDD Certificate_3.pdf"),
      item("3rd Tab Documents/15. Secreterial DDR_1.pdf"),
      item("3rd Tab Documents/16. Site Visit Report.pdf"),
      item("3rd Tab Documents/17. Industry Rport.pdf"),
      item("3rd Tab Documents/18. Purchase agreement_Ayodhya_Advika.pdf"),
      item("3rd Tab Documents/19. JDA_Ayodhya.pdf"),
      item("3rd Tab Documents/20. Lease Deed.pdf"),
      item("3rd Tab Documents/21. Sanction Letter_CSL.pdf"),
      item("3rd Tab Documents/22. Non-compete agreement.pdf"),
      item("3rd Tab Documents/23. Master Approval Letter.pdf"),
      item("3rd Tab Documents/24. MoU_Aurika Homes.pdf"),
      item("3rd Tab Documents/24. MoU_Aurika Projects.pdf"),
      item("3rd Tab Documents/25. Logo License agreements.pdf"),
      item("3rd Tab Documents/26. Valuation report.pdf"),
      item("3rd Tab Documents/27. CA_Capitalisation Statement.pdf"),
      item("3rd Tab Documents/27. CA_Delay in filling.pdf"),
      item("3rd Tab Documents/27. CA_Director and KMPs remuneration.pdf"),
      item("3rd Tab Documents/27. CA_Financial Indebtedness.pdf"),
      item("3rd Tab Documents/27. CA_KPI.pdf"),
      item("3rd Tab Documents/27. CA_Mandate booking.pdf"),
      item("3rd Tab Documents/27. CA_Material Creditors.pdf"),
      item("3rd Tab Documents/27. CA_Net worth.pdf"),
      item("3rd Tab Documents/27. CA_Other Financial Information.pdf"),
      item("3rd Tab Documents/27. CA_Related Party Transaction.pdf"),
      item("3rd Tab Documents/27. CA_Revenue Bifurcation.pdf"),
      item("3rd Tab Documents/28. CA_Project Construction Cost-Veda.pdf"),
      item("3rd Tab Documents/28. CA_Promoter Guarantees.pdf"),
      item("3rd Tab Documents/29. Cost of Acquisition.pdf"),
    ],
  },
];

const MaterialDocuments = () => {
  const pageTitle = "Material Documents";
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const tableData = tabs.find((tab) => tab.id === activeTab)?.rows || [];

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <div className="main-content">
        <Header />

        <div
          className="relative h-[30vh] sm:h-[60vh] md:h-[50vh] lg:h-[70vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Material Documents
          </div>
        </div>

        <div className="w-[92%] md:w-[70%] mx-auto mb-3 flex overflow-x-auto whitespace-nowrap gap-2 sm:gap-6 border-b border-gray-200">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`relative text-sm font-medium px-3 py-2 transition-colors ${
                activeTab === tab.id
                  ? "!text-[#F26624] !bg-transparent"
                  : "!text-gray-500 hover:text-gray-700 !bg-transparent"
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {activeTab === tab.id && (
                <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
              )}
            </button>
          ))}
        </div>

        <div className="w-[92%] md:w-[70%] mx-auto border border-gray-300 mb-4">
          <div className="bg-[#F26624] text-white text-sm font-medium py-2 px-1">
            <div className="flex">
              <div className="w-12 text-center border-r border-gray-300">
                S.No
              </div>
              <div className="flex-1 text-center border-r border-gray-300">
                Particular
              </div>
              <div className="w-24 text-center">Link</div>
            </div>
          </div>

          {tableData.map((row, index) => {
            if (row.type === "section-header" || row.type === "sub-header") {
              const isSection = row.type === "section-header";
              return (
                <div
                  key={index}
                  className="flex border-b border-gray-300 text-sm bg-white"
                >
                  <div className="w-12 border-r border-gray-300" />
                  <div
                    className={`flex-1 px-4 py-2 font-semibold border-r border-gray-300 ${
                      isSection ? "text-[#F26624]" : "text-gray-600 bg-gray-100"
                    }`}
                  >
                    {row.title}
                  </div>
                  <div className="w-24" />
                </div>
              );
            }

            return (
              <div
                key={index}
                className="bg-white border-b border-gray-300 text-xs hover:bg-gray-50"
              >
                <div className="flex">
                  <div className="w-12 text-center border-r border-gray-300 py-2">
                    {row.id}
                  </div>
                  <div className="flex-1 px-3 py-2 border-r border-gray-300">
                    {row.description}
                  </div>
                  <div className="w-24 flex items-center justify-center">
                    <a
                      href={row.link}
                      target="_blank"
                      rel="noreferrer"
                      className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                    >
                      Click Here
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default MaterialDocuments;
